import { useSelector } from 'react-redux';
import { useCouponValidity } from '../couponValidityContext';
import { DotTypingLoader } from '../../../../../../loaders/dotTypingLoader'

import { Container } from './style';

export function ButtonNextForm() {
    const {  handleCreateCoupon, handleEditCoupon, isLoading } = useCouponValidity()

    const typeModalForms = useSelector(state => state.modalForms.typeModal)

    function verifyingButtonProperties() {
        return typeModalForms === 0 
        ? {title: 'Editar Cupom', functionOnClick: handleEditCoupon} 
        : {title: 'Criar Cupom', functionOnClick: handleCreateCoupon}
    }
    
    return(
        <Container onClick={() => verifyingButtonProperties().functionOnClick()}>

            {
            isLoading ?
                <DotTypingLoader />
                :
                verifyingButtonProperties().title
            }
        </Container>
    )
}

